import { Col, Row } from "antd";
import React from "react";

const ImageRowContainer = ({
  props,
  className,
  titleClass,
  subTitleClass,
  colsize1 = null,
  colsize2 = null,
}) => {
  const { imgSrc, title, subTitle } = props;

  return (
    <div className={`image-content-container ${className}`}>
      <Row>
        <Col
          md={colsize1 ? colsize1 : 3}
          sm={colsize1 ? colsize1 : 3}
          xs={colsize1 ? colsize1 : 3}
        >
          <div className="image-container">
            <img src={imgSrc} alt={imgSrc} />
          </div>
        </Col>
        <Col
          md={colsize2 ? colsize2 : 21}
          sm={colsize2 ? colsize2 : 21}
          xs={colsize2 ? colsize2 : 21}
        >
          <div className="image-content">
            <div className={`${titleClass} image-title`}>{title}</div>
            <div className={`${subTitleClass} image-sub-title`}>{subTitle}</div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ImageRowContainer;
